<div class="_clients-desktop-page">

	<ng-container *ifUserHasNotPermissions="[UserPermissions.ListClients]">

		<div class="_client-client-only">
			<p [translate]="'CLIENT.CREATE_ROLE_DISCLAIMER'"></p>
			<button type="button" button class="_button _add-button" (click)="openCreateClient()">
				<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
				<span>{{ 'CLIENT.CREATE' | translate}}</span>
			</button>
		</div>
		
	</ng-container>

	<table-desktop-component 
		*ifUserHasPermissions="[UserPermissions.ListClients]"
		[headers]="tableHeaders"
		[filters]="tableFilters"
		[dataRequest]="dataRequest" 
		(dataChanged)="dataChanged($any($event))" 
		stateKey="clients"
		class="_wrap"
	>

		<button type="button" button class="_button _add-button" (click)="openCreateClient()">
			<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
			<span>{{ 'CLIENT.CREATE' | translate}}</span>
		</button>

		<ng-container *ifUserHasPermissions="[UserPermissions.ImportClients]" button>
			<button type="button" button class="_button _upload-button" (click)="openImportClients()">
				<ion-icon src="./assets/icons/upload-outline.svg"></ion-icon>
				<span>{{ 'CLIENTS_IMPORT.IMPORT' | translate}}</span>
			</button>
		</ng-container>

		<ng-container *ifUserHasPermissions="[UserPermissions.ExportClients]" button>
			<button type="button" button class="_button _export-button" (click)="getDigibankReport()">
				<ion-icon src="./assets/icons/download-outline.svg"></ion-icon>
				<span>{{ 'CLIENT.EXPORT_WSE' | translate}}</span>
			</button>
			<button type="button" button class="_button _export-button" (click)="getClientsExport()">
				<ion-icon src="./assets/icons/download-outline.svg"></ion-icon>
				<span>{{ 'CLIENT.EXPORT' | translate}}</span>
			</button>
		</ng-container>

		<button *ifUserHasPermissions="[UserPermissions.MergeClients]" type="button" button class="_button _edit-button _merge-button" (click)="openMergeClients()">
			<ion-icon src="./assets/icons/git-merge-outline.svg"></ion-icon>
			<span>{{ 'MERGE_CLIENTS.TITLE' | translate}}</span>
		</button>

		<ion-row data class="_row _data ion-align-items-center" *ngFor="let client of clients">
			<table-col [size]="3">{{client.firstname}} {{client.lastname}}<br/>
				<span style="color: grey">
					<ng-container *ngIf="client.birthDate">{{client.birthDate | date:"dd/MM/yyyy"}}</ng-container>
					<ng-container *ngIf="client.birthDate && client.gender"> - </ng-container>
					<ng-container *ngIf="client.gender">{{client.gender}}</ng-container>
				</span>
			</table-col>
			<table-col [size]="4">
				<span [navigate]="[InternalNavigationType.address, client.Address]">{{client.Address | address}}</span>
			</table-col> 
			<table-col [size]="2">
				<span [navigate]="[InternalNavigationType.email, client.email]">{{client.email}}</span>
			</table-col> 
			<table-col [size]="2">
				<span [navigate]="[InternalNavigationType.phone, client.telephone]">{{client.telephone}}</span>
			</table-col> 
			<table-col [size]="2">
				<span [navigate]="[InternalNavigationType.phone, client.landline]">{{client.landline}}</span>
			</table-col> 
			<table-col  [size]="2" class="_center">
				<button type="button" class="_button _info-button" (click)="openClient(client)" title="{{ 'CLIENT.EDIT' | translate}}">
					<ion-icon src="./assets/icons/edit-outline-simple.svg"></ion-icon>
				</button>
			</table-col>
		</ion-row>
	</table-desktop-component>		

</div>
